<template>
  <div outer fill>
    <!-- gap 8, not 10: at 920 the list is only about 195px wide -->
    <div header style="gap: 8px">
      <span ellipsis>Carts</span>
      <div class="mv-seg mv-seg--sm">
        <button type="button" class="mv-seg-btn" :class="{ 'is-on': !mine }" :aria-pressed="String(!mine)" @click="showMine(false)">All</button>
        <button type="button" class="mv-seg-btn" :class="{ 'is-on': mine }" :aria-pressed="String(mine)" @click="showMine(true)">Mine</button>
      </div>
      <button type="button" class="mv-iconbtn mv-iconbtn--sm" style="margin-left: auto" title="New cart" aria-label="New cart" @click="newCart()">
        <v-icon size="16">mdi-plus</v-icon>
      </button>
    </div>

    <!-- a container, so narrow rows can drop the length (see .mv-cartrow-dur) -->
    <div style="flex: 1; min-height: 0; overflow: auto; padding: 6px; display: flex; flex-direction: column; gap: 2px; container-type: inline-size">
      <CartListItem v-for="cart in $store.state.carts" :key="cart.id" :value="cart"></CartListItem>
    </div>
    <div footer>
      <span>{{ plural($store.state.carts ? $store.state.carts.length : 0, "cart") }}</span>
    </div>
  </div>
</template>

<script>
import { plural } from "@/scripts/plural.js";

export default {
  props: {},
  data: () => {
    return {};
  },
  computed: {
    mine() {
      return !!this.$store.state.cartsOwner;
    },
  },
  methods: {
    plural,
    showMine(mine) {
      this.$store.state.cartsOwner = mine ? this.$store.state.authUser.username : "";
      this.$store.state.requestCarts();
    },
    newCart() {
      this.$store.state.showPromptDialog("New cart name:", "New cart", (name) => this.$store.state.addCart(name));
    },
  },
  mounted() {},
  watch: {},
  beforeDestroy() {},
};
</script>

<style></style>
